"use client";

import { c as _c } from "react/compiler-runtime";
import { LayoutRelatedSubjects } from "@/components/terra/layouts/LayoutRelatedSubjects/LayoutRelatedSubjects";
import { ThemeDivider } from "@/components/terra/component/ThemeDivider/ThemeDivider";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { handleButtons } from "@/lib/utils";
import { normalizeImageObject } from "@/components/terra/utils/renderImage";
export default function MXPLayoutRelatedSubjects(props) {
  const $ = _c(31);
  const {
    value,
    index,
    divider,
    headerElement,
    isLCP,
    lang
  } = props;
  const t0 = value.buttonsCollection?.items;
  let t1;
  if ($[0] !== lang || $[1] !== t0) {
    t1 = handleButtons(t0, true, lang);
    $[0] = lang;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const buttons = t1;
  let t2;
  if ($[3] !== lang || $[4] !== value.relatedListItemsCollection?.items) {
    let t3;
    if ($[6] !== lang) {
      t3 = item => {
        const link = item?.link ? handleButtons([item.link], true, lang)?.[0] : undefined;
        const destinationData = item?.destination ? handleButtons([item.destination], false, lang) : undefined;
        const destination = destinationData?.[0]?.destination;
        return {
          image: normalizeImageObject(item.imageListItemImage),
          header: item.header,
          description: item.shortDescription,
          ...(link ? {
            link
          } : destination ? {
            destination
          } : {})
        };
      };
      $[6] = lang;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = (value.relatedListItemsCollection?.items ?? []).filter(Boolean).map(t3);
    $[3] = lang;
    $[4] = value.relatedListItemsCollection?.items;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const itemsData = t2;
  const dividerClasses = `section-divider-wrap ${value.theme}`;
  const t3 = value.eyebrow;
  const t4 = value.header;
  const t5 = value.subheader;
  const t6 = value?.description?.json;
  let t7;
  if ($[8] !== t6) {
    t7 = documentToHtmlString(t6);
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = value.isHeaderBig || false;
  const t9 = value?.componentImagePriority;
  let t10;
  if ($[10] !== buttons || $[11] !== headerElement || $[12] !== index || $[13] !== isLCP || $[14] !== itemsData || $[15] !== t7 || $[16] !== t8 || $[17] !== t9 || $[18] !== value.eyebrow || $[19] !== value.header || $[20] !== value.relatedSubjectsHeader || $[21] !== value.subheader || $[22] !== value.theme) {
    t10 = <LayoutRelatedSubjects key={index} eyebrow={t3} header={t4} subheader={t5} description={t7} relatedListItemsTitle={value.relatedSubjectsHeader} relatedListItems={itemsData} presetTheme={value.theme} buttons={buttons} isWrapped={true} isHeaderBig={t8} componentImagePriority={t9} headerElement={headerElement} isLCP={isLCP} />;
    $[10] = buttons;
    $[11] = headerElement;
    $[12] = index;
    $[13] = isLCP;
    $[14] = itemsData;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = value.eyebrow;
    $[19] = value.header;
    $[20] = value.relatedSubjectsHeader;
    $[21] = value.subheader;
    $[22] = value.theme;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== divider || $[25] !== dividerClasses || $[26] !== value.theme) {
    t11 = divider && <div className={dividerClasses}><ThemeDivider currentTheme={value.theme} /></div>;
    $[24] = divider;
    $[25] = dividerClasses;
    $[26] = value.theme;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t10 || $[29] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
}